import React from 'react'

export default ({ portfolioLinks }) => {
  return (
    <section className="bg-light page-section" id="portfolio">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 text-center">
            <h2 className="section-heading text-uppercase">More</h2>
            <h3 className="section-subheading text-muted">Read more on our recent work and or services.</h3>
          </div>
        </div>
        <div className="row">

          <div className="col-md-3 col-sm-4 portfolio-item">
            <a className="portfolio-link" data-toggle="modal" href="#">
              <div className="portfolio-hover">
                <div className="portfolio-hover-content">
                </div>
              </div>
              <img className="img-fluid" src={require('../assets/img/ecom.png')} alt="" />
            </a>
            <div className="portfolio-caption">
              <h4>software</h4>
              <p className="text-muted">e-commerce plaforms</p>
            </div>
          </div>


          <div className="col-md-3 col-sm-4 portfolio-item">
            <a className="portfolio-link" data-toggle="modal" href="#">
              <div className="portfolio-hover">
                <div className="portfolio-hover-content">
                </div>
              </div>
              <img className="img-fluid" src={require('../assets/img/web.png')} alt="" />
            </a>
            <div className="portfolio-caption">
              <h4>design</h4>
              <p className="text-muted">web design</p>
            </div>
          </div>


          <div className="col-md-3 col-sm-4 portfolio-item">
            <a className="portfolio-link" data-toggle="modal" href="#">
              <div className="portfolio-hover">
                <div className="portfolio-hover-content">
                </div>
              </div>
              <img className="img-fluid" src={require('../assets/img/graphics2.png')} alt="" />
            </a>
            <div className="portfolio-caption">
              <h4>graphics</h4>
              <p className="text-muted">graphics & logo design</p>
            </div>
          </div>


          <div className="col-md-3 col-sm-4 portfolio-item">
            <a className="portfolio-link" data-toggle="modal" href="#">
              <div className="portfolio-hover">
                <div className="portfolio-hover-content">
                </div>
              </div>
              <img className="img-fluid" src={require('../assets/img/tab.png')} alt="" />
            </a>
            <div className="portfolio-caption">
              <h4>Apps</h4>
              <p className="text-muted">mobile app development</p>
            </div>
          </div>


        </div>
      </div>
    </section>
  )
}